/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RasterCategoryDto } from '../../models/raster-category-dto';

export interface CreateRasterCategory$Params {
      body: RasterCategoryDto
}

export function createRasterCategory(http: HttpClient, rootUrl: string, params: CreateRasterCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, createRasterCategory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RasterCategoryDto>;
    })
  );
}

createRasterCategory.PATH = '/v1/rastercategory';
